// extracted by mini-css-extract-plugin
export var closer = "ExpandingSection-module--closer--dec7a";
export var expanderButton = "ExpandingSection-module--expanderButton--0b523";